var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5217 2.43411H3.47788C2.66183 2.43411 2 3.0733 2 3.86128V20.9274C2 21.7153 2.66183 22.3537 3.47788 22.3537H20.5217C21.3386 22.3537 21.9996 21.7145 21.9996 20.9274V3.86128C21.9996 3.0733 21.3378 2.43411 20.5217 2.43411ZM8.07779 19.1042H5.08508V10.1364H8.07779V19.1042ZM6.58224 8.91239H6.56296C5.55816 8.91239 4.90918 8.2236 4.90918 7.36282C4.90918 6.48283 5.57824 5.81325 6.60232 5.81325C7.62559 5.81325 8.2561 6.48283 8.27538 7.36282C8.27538 8.2236 7.62559 8.91239 6.58224 8.91239ZM18.8696 19.1042H15.8768V14.3075C15.8768 13.1019 15.4439 12.2795 14.3612 12.2795C13.5339 12.2795 13.0416 12.8339 12.8255 13.3699C12.7468 13.5611 12.7267 13.8299 12.7267 14.0971V19.105H9.73399C9.73399 19.105 9.77334 10.9787 9.73399 10.1372H12.7267V11.4067C13.1243 10.7955 13.8367 9.92677 15.4238 9.92677C17.3925 9.92677 18.8687 11.2083 18.8687 13.9627V19.1042H18.8696Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinW);
export default __webpack_public_path__ + "static/media/linkedin-w.4c05973ea6daac02360487b9417d6560.svg";
export { ForwardRef as ReactComponent };